var _style, _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokerstars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 452.6 76",
    style: {
      enableBackground: "new 0 0 452.6 76"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  .st0{fill-rule:evenodd;clip-rule:evenodd;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#D70022;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFE;}\n ")), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "ns_sfw;"
  }, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    bottomLeftOrigin: "true",
    height: 76,
    width: 452.6,
    x: -251.1,
    y: -201.4
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.1,31.8c0,7.1-4.5,11.9-13.3,11.9H100v11.5h-8.3V20.8h19.7C118.9,20.8,123.1,24.9,123.1,31.8 M114.4,31.9 c0-3.3-2.1-4.6-5.2-4.6H100v9.6h8.5C112.4,36.9,114.4,35.3,114.4,31.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.9,38.1c0,11.7-8.5,17.7-19.1,17.7c-10.6,0-19.1-6-19.1-17.7c0-11.9,8.5-17.9,19.1-17.9 C156.4,20.2,164.9,26.2,164.9,38.1 M156.1,38.1c0-7.3-4.5-10.9-10.2-10.9c-5.7,0.1-10.2,3.6-10.2,10.9c0,7.1,4.5,10.8,10.2,10.8 C151.6,48.8,156.1,45.2,156.1,38.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "184.2,41.1 178.6,47.5 178.6,55.3 170.2,55.3 170.2,20.8 178.5,20.8 178.5,37 193.1,20.8 203.5,20.8  189.8,35.3 205,55.3 194.7,55.3 184.2,41.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "217.8,27.7 217.8,34.3 234.8,34.3 234.8,40.9 217.8,40.9 217.8,48.2 236.8,48.2 236.8,55.3  209.4,55.3 209.4,20.8 236.8,20.8 236.8,27.7 217.8,27.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M257.2,42.9h-5.9v12.4h-8.3V20.8h20c8,0,11.7,4.6,11.7,10.6c0,5.6-3.1,9.8-8.4,10.9l10.2,13h-10.1L257.2,42.9z  M251.3,36.2h9.1c3.4,0,5.7-1.3,5.7-4.4c0-3.3-2.3-4.5-5.4-4.5h-9.3V36.2z M251.3,36.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M295,20.2c4.2,0,8.4,0.4,12.4,1.2v7.2c-4.3-1-8.6-1.5-13-1.5c-4.1,0-6.6,1.3-6.6,3.4c-0.1,2.1,1.3,3,4.4,3.2 l6.6,0.4c6.9,0.4,10.9,3.6,10.9,10.1c0,8.8-7.4,11.5-15.9,11.5c-4.3,0-8.6-0.4-12.9-1.2v-7.4c4.3,0.9,8.7,1.4,13.1,1.4 c5.3,0,7.6-1.3,7.6-3.9c0-2.2-2.3-3.1-5.4-3.2l-5.5-0.3c-6.8-0.3-11-3.4-11-9.4C279.8,23.7,286.5,20.2,295,20.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "343.7,27.9 332.2,27.9 332.2,55.3 323.9,55.3 323.9,27.9 312.3,27.9 312.3,20.8 343.7,20.8  343.7,27.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M369.4,48.1H353l-2.8,7.2h-9l14.1-34.5h11.7l14.1,34.5h-9L369.4,48.1z M366.8,41.3l-5.6-14.5l-5.6,14.5H366.8z  M366.8,41.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M399.8,42.9h-5.9v12.4h-8.3V20.8h20c8,0,11.7,4.6,11.7,10.6c0,5.6-3.1,9.8-8.4,10.9l10.3,13h-10.1L399.8,42.9z  M393.9,36.2h9.1c3.4,0,5.7-1.3,5.7-4.4c0-3.3-2.3-4.5-5.4-4.5h-9.3V36.2z M393.9,36.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M437.6,20.2c4.2,0,8.6,0.4,12.7,1.2v7.2c-4.3-1-8.9-1.5-13.3-1.5c-4.1,0-6.5,1.3-6.6,3.4 c-0.1,2.1,1.3,3,4.4,3.2l6.6,0.4c6.9,0.4,11.1,3.6,11.1,10.1c0,8.8-7.7,11.5-16.2,11.5c-4.3,0-8.6-0.4-12.9-1.2v-7.4 c4.3,0.9,8.7,1.4,13.1,1.4c5.3,0,7.6-1.3,7.6-3.9c0-2.2-2.3-3.1-5.4-3.2l-5.5-0.3c-6.8-0.3-11-3.4-11-9.4 C422.4,23.7,429.1,20.2,437.6,20.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.6,16.1C39.7,6.2,33.3,0,33.3,0S27,6.2,17,16.1C11.8,21.3,0,34.3,0,47.3c0,8.6,7,15.6,15.6,15.6 c5.7,0,10.6-3,13.3-7.5c0.3-0.3,0.7-0.6,1.2-0.6c0.8,0,1.5,0.6,1.4,1.3c-0.6,4.7-3.2,16.1-13.5,20h30.5C38.2,72.1,35.6,60.7,35,56 c-0.1-0.7,0.7-1.3,1.4-1.3c0.5,0,1,0.3,1.2,0.6c2.7,4.5,7.7,7.5,13.3,7.5c8.6,0,15.6-7,15.6-15.6C66.6,34.3,54.9,21.3,49.6,16.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "33.3,16.1 37.6,29.1 51.3,29.1 40.2,37.2 44.4,50.2 33.3,42.2 22.3,50.2 26.5,37.2 15.4,29.1  29.1,29.1 33.3,16.1  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPokerstars);
export default __webpack_public_path__ + "static/media/pokerstars.f3ea66b6c66c503a9b105bcf379499eb.svg";
export { ForwardRef as ReactComponent };